// Gebruik deze file voor scripts die nodig zijn op alle pagina's van de website
import { setupAccordion } from "./components/accordion.component"
import { autoPlay } from "./components/autoplayfallback.component"
import { setupDynamicSubMenu } from "./components/dynamicSubMenu.component"
import { setupImageSliders } from "./components/imageSlider.component"
// import { setupInfobar } from "./components/infobar.component"
import { setupMobileMenu } from "./components/mobileMenu.component"
import { playPause } from "./components/playpause.component"
import { setupScrollFader } from "./components/scrollFader.component"
import { setupNavigationVisibility } from "./components/showHideNavigation.component"
import { setupSubMenu } from "./components/submenu.component"
import { InitVideoPlayer } from "./components/videoPlay.component"
import { onDocumentReady } from "~/utils/onDocumentReady.util"

onDocumentReady(() => {
  InitVideoPlayer()
  autoPlay()
  playPause()
  setupScrollFader()
  setupMobileMenu()
  setupSubMenu()
  setupImageSliders()
  setupNavigationVisibility()
  setupAccordion()
  setupDynamicSubMenu()
  // setupInfobar()
})
